import React, { useState } from 'react';
import Link from 'next/link';
import { useMutation } from 'react-query';
import { jobsFav } from 'services/pharmaJobs';
import { copyTextToClipboard } from 'utils/clipboard';
import { getErrorText } from 'utils/geterrortext';
import { isUserLoggedIn } from 'utils/authentication';
import { marked } from 'marked';

import RichTextEditor from '@core/components/richtexteditor/RichTextEditor';
import JobApplyButton from './jobapplybutton/JobApplyButton';

import TickIcon from 'assets/icons/tick-square.svg';
import StarIcon from 'assets/icons/star-rate-empty.svg';
import { CopySuccess } from 'iconsax-react';
import BlurCompanyImage from 'assets/images/pages/jobs/blur-company-logo.png';
import UnlockImage from 'assets/images/pages/jobs/unlock.png';
import LinkedinImage from 'assets/images/pages/jobs/linkedin.svg';

import classes from './JobDetailsCard.module.scss';
import LinkButton from '@core/components/linkbutton/LinkButton';



const JobDetailsCard = ({ data, toast }) => {
    const [isFav, setIsFav] = useState(data?.data?.is_favorite);
    const MASKED_JOB_DESCRIPTION = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, urna eu tincidunt consectetur, nisi nisl aliquam eros, vitae cursus enim urna at sapien. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Suspendisse potenti. Etiam nec velit nec urna dictum cursus. <br /> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, urna eu tincidunt consectetur, nisi nisl aliquam eros, vitae cursus enim urna at sapien. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, urna eu tincidunt consectetur, nisi nisl aliquam eros, vitae cursus enim urna at sapien.<br /> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, urna eu tincidunt consectetur, nisi nisl aliquam eros, vitae cursus enim urna at sapien. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, urna eu tincidunt consectetur, nisi nisl aliquam eros, vitae cursus enim urna at sapien.";
    const { mutate: addToFav } = useMutation(jobsFav.POST, {
        onError: (error) => {
            toast(getErrorText(error), 'Alert');
            setIsFav(false);
        }
    });
    const { mutate: deleteFromFav } = useMutation(jobsFav.DELETE, {
        onError: (error) => {
            toast(getErrorText(error), 'Alert');
            setIsFav(true);
        }
    });
    const onFavClick = (e) => {
        e.stopPropagation();
        if (isUserLoggedIn()) {
            setIsFav((prevState) => !prevState);
            isFav ? deleteFromFav(data?.data?.id) : addToFav(data?.data?.id);
        } else {
            toast('Please login to add this job to your favorites');
        }
    };
    const onShareClick = (e) => {
        e.stopPropagation();
        copyTextToClipboard(`${window.location.host}/jobs/job-details/${data.data.id}/${data.data.slug}`);
        toast('Job post URL copied to clipboard');
    };
    return (
        <div className={`${classes['job-board-detail-wrapper']}`}>
            <div
                className={`${classes['job-board-detail-header-wrapper']} d-flex flex-column p-3 p-md-3 p-xl-4 gap-3`}>
                <div
                    className={`${classes['job-board-detail-header-title']} d-flex flex-row justify-content-between align-items-center`}>
                    <div className="d-flex flex-row gap-2 align-items-center align-items-center">
                        <div>
                            {data.data.masked ? (
                                <img src={BlurCompanyImage.src} alt='company logo' />
                            ) : (
                                <>
                                    {data.data.company?.logo ? (
                                        <img src={data.data.company.logo} alt='company logo' />
                                    ) : (
                                        <span>{data.data.company?.name[0].toUpperCase()}</span>
                                    )}
                                </>
                            )}

                        </div>
                        <h5>{data.data.masked ? <span style={{ filter: 'blur(5.5px)' }}>Company Name</span> : data.data.company?.name}</h5>
                    </div>
                    <div className="d-flex flex-row align-items-center gap-2">
                        <p className={`${classes['published-at']} d-none d-lg-block`}>{data.data.published_at}</p>
                    </div>
                </div>
                <p className={`${classes['published-at']} d-block d-lg-none`}>{data.data.published_at}</p>
                <div
                    className={`${classes['job-board-detail-header-body']} d-flex flex-column flex-xl-row justify-content-between align-items-start align-items-xl-center gap-3`}>
                    <div className="d-flex flex-column gap-2">
                        <h5>{data.data.title}</h5>
                        <p>{data.data.location} </p>
                    </div>
                </div>
                <div className='d-flex flex-column flex-md-row align-items-md-center align-items-start justify-content-between'>
                    <div className="d-flex flex-row align-items-center gap-2 mb-3 mb-md-0">
                        <button
                            className={`${classes['job-board-card-fav']}`}
                            onClick={onShareClick}>
                            <CopySuccess size={30} variant='TwoTone' color='#403f3f' /> Copy URL 
                        </button>
                        <button
                            className={`${classes['job-board-card-fav']} ${isFav ? classes['job-board-card-fav-enabled'] : ''
                                }`}
                            onClick={onFavClick}>
                            <StarIcon /> Save
                        </button>
                    </div>
                    <JobApplyButton activeJob={data?.data?.id} toast={toast} />
                </div>
            </div>
            <div
                className={`${classes['job-board-detail-body-wrapper']} d-flex flex-column gap-3 gap-md-4 gap-xl-5 p-3 p-md-4 p-xl-5`}>
                <div
                    className={`${classes['job-post-detail-border-detail']} d-flex flex-column align-items-start justify-content-center gap-3 mb-2 mb-md-4`}>
                    <div
                        className={`${classes['body']} d-flex flex-column flex-xl-row align-items-start justify-content-start align-items-xl-center gap-3`}>
                        {data?.data?.salary_range && (
                            <div className="w-100 d-flex flex-row gap-2 flex-xl-column justify-content-start align-items-xl-start align-items-center">
                                <h5>
                                    Salary Range
                                </h5>
                                <p>{data?.data?.salary_range}</p>
                            </div>
                        )}
                        {data?.data?.seniority && (
                            <div className="w-100 d-flex flex-row gap-2 flex-xl-column justify-content-start align-items-xl-start align-items-center">
                                <h5>
                                    Seniority
                                </h5>
                                <p>{data?.data?.seniority}</p>
                            </div>
                        )}
                        {data?.data?.location_type && (
                            <div className="w-100 d-flex flex-row gap-2 flex-xl-column justify-content-start align-items-xl-start align-items-center">
                                <h5>
                                    Location Type
                                </h5>
                                <p>{data?.data?.location_type}</p>
                            </div>
                        )}
                        {data?.data?.employment_type && (
                            <div className="w-100 d-flex flex-row gap-2 flex-xl-column justify-content-start align-items-xl-start align-items-center">
                                <h5>
                                    Job Type
                                </h5>
                                <p>{data?.data?.employment_type}</p>
                            </div>
                        )}
                    </div>
                </div>
                <div className={`${classes['job-post-detail-detail']} d-flex flex-column gap-3`}>
                    <div>
                        <h5>Job Description</h5>
                        <div className={data?.data?.masked ? classes.masked : ''}>
                            <RichTextEditor isHtml={true} readMore={true} data={data?.data?.masked ? MASKED_JOB_DESCRIPTION : marked.parse(data?.data?.description || '')} />
                        </div>
                        {data?.data?.masked && (
                            <div className='d-flex justify-content-center'>
                                <div className={classes['unlock']}>
                                    <img src={UnlockImage.src} alt='pharma jobs' />
                                    <h5>
                                        Unlock Full Job Details & Apply
                                    </h5>
                                    <p>
                                        Want to see the company name, full job description, and direct application link?
                                        Subscribe to Pharmuni Premium and get unlimited access.
                                    </p>
                                    <LinkButton to={'/plans'} kind='primary-color' >Subscribe</LinkButton>
                                </div>
                            </div>
                        )}
                    </div>
                    {(!data.data?.masked && data.data.hiring_team_member) && (
                        <div className={classes['hiring-team']}>
                            <h4>Hiring Team</h4>
                            <div className='d-flex justify-content-start align-items-center'>
                                {data.data.hiring_team_member.image && (
                                    <img src={data.data.hiring_team_member.image} alt='hiring team' />
                                )}
                                <div>
                                    <div className='d-flex justify-content-start align-items-center gap-2'>
                                        <h5 className='m-0'>{data.data.hiring_team_member.full_name}</h5>
                                        {data.data.hiring_team_member.linkedin_url && (
                                            <a href={data.data.hiring_team_member.linkedin_url} target='_blank' rel='noopener noreferrer'>
                                                <LinkedinImage />
                                            </a>
                                        )}
                                    </div>

                                    <p>{data.data.hiring_team_member.role}</p>
                                </div>
                            </div>
                        </div>
                    )}
                    {(!data.data?.masked && data.data.company?.name && data.data.company?.description) && (
                        <div>
                            <h5>About {data.data.company?.name}</h5>
                            <div>
                                <RichTextEditor isHtml={true} readMore={true} data={data?.data?.company?.description} />
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default JobDetailsCard;